import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography, useTheme } from '@mui/material';

const LinkButton = ({ url, title, onClick, variant, ...rest }) => {
  const theme = useTheme();
  return (
    <Button
      id={`navbar-${url}-desktop`}
      key={title}
      onClick={onClick}
      variant={variant}
      {...rest}
    >
      <Typography
        variant="small_3"
        color={theme.palette.neutral.A800}
        fontWeight={700}
        textTransform="none"
      >
        {title}
      </Typography>
    </Button>
  );
};

export default LinkButton;

LinkButton.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
};
